import {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router';

import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import useAppContext from 'conf/AppContext';


export default function VerifyAccount() {
  const appContext = useAppContext();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const key = searchParams.get('key');
  const [error, setError] = useState(null);
  const [confirmed, setConfirmed] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        if (key && location.pathname.includes('/verify/account')) {
          const rez = await appContext.api.get('api/v1/users/verify/account', {
            searchParams: {
              key,
            },
            parseJson: true,
          });
          setConfirmed(rez.message);
        }
      } catch (err) {
        setError(<KyError kyError={err} />);
      }
    };
    loadData();
  }, []);

  const renderFn = (content) => (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-6 col-sm-12" style={{marginTop: '5em'}}>
          <div className="card">
            <div className="card-body">
              {content}
              <hr className="my-3" />
              <div className="col d-flex justify-content-start">
                <div className="btn btn-outline-light">
                  <Link to="/login" style={{textDecoration: 'none'}}>Go to login</Link>
                </div>
              </div>
              <div className="col d-flex justify-content-end">
                <div className="link-dark">
                  <Link to="/resetpassword">Forgot password?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (!key) {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-6 col-sm-12" style={{marginTop: '100px'}}>
            <div className="card">
              <div className="card-body">
                <div className="alert alert-dismissible alert-danger">
                  Invalid link. Please check the link and try again.
                </div>
                <hr className="my-3" />

                <div className="col d-flex justify-content-start">
                  <div className="btn btn-outline-light">
                    <Link to="/login" style={{textDecoration: 'none'}}>Go to login</Link>
                  </div>
                </div>
                <div className="col d-flex justify-content-end">
                  <div className="link-dark">
                    <Link to="/resetpassword">Forgot password?</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  let content = <Loading />;
  if (error) {
    content = renderFn(error);
  } else if (confirmed) {
    content = renderFn(confirmed);
  }

  return content;
}
